import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import TextField from '../../OrderEntry/ui/TextField';
import Select from 'react-select';
import { Client, DropdownOption, State } from '../types';
import {AsYouType} from 'libphonenumber-js'
import axios from 'axios';
import produce from 'immer';
import Button from '../../../components/Button';
import PhoneNumberInput from '../../../components/PhoneNumberInput';
import { checkIfInputContainsLettersOrNull } from '../../../components/utilities/functions';

const OuterWrap = styled.div`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  width: 805px;
  margin: 40px auto;
  padding-bottom: 40px;
  position: relative;
`;
const Header = styled.div`
  font-size: 20px;
  font-weight: 700;
  padding: 32px;
  border-bottom: 1px solid #e5e5ea;
`;
const Section = styled.div`
  padding: 32px;
  border-bottom: 1px solid #e5e5ea;
`;
const SectionHeader = styled.div`
  font-size: 16px;
  font-weight: 700;
  width: 136px;
  margin-right: 16px;
`;
const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    marginTop: 8,
    width: 280,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #f5f5f5',
    height: 48,
  }),
};
const SuccessPopup = styled.span`
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  position: absolute;
  right: 24px;
  bottom: 0px;
`;
interface Props {
  clientId: number;
}
interface Props {
  clientId: number;
}
const ProfilePage = (props: Props) => {
  const [states, setStates] = useState<DropdownOption[]>([]);
  const [client, setClient] = useState<Client>();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const getStates = async () => {
    const { data } = await axios.get('/api/ClientProperty/GetStates');
    const mappedData = data.map(s => ({ value: s.id, label: s.name }));
    setStates(mappedData);
  };
  const getClient = async () => {
    const { data } = await axios.get(`/api/ClientProfile/GetClientInformation/${props.clientId}`);
    setClient({
      ...data,
      phone: checkIfInputContainsLettersOrNull(data.phone)? data.phone : new AsYouType('US').input(data.phone),
      stateId: states.find(s => {
        return s.value === data?.stateId;
      }),
    });
  };
  const changeClientInfo = (label: keyof Partial<Client>, value: any) => {
    const newClientInfo = produce(client, draft => {
      (draft[label] as any) = value;
    });
    setClient(newClientInfo);
  };
  const onSave = async (client: Client) => {
    setLoading(true);
    await axios.post('/api/ClientProfile/UpdateClientInformation', {
      ...client,
      extension: parseInt(client?.extension?.toString()),
      stateId: client?.stateId.value,
    });
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 2000);
    setLoading(false);
  };

  useEffect(() => {
    getClient();
  }, [props.clientId, JSON.stringify(states)]);

  useEffect(() => {
    getStates();
  }, []);

  return (
    <OuterWrap>
      <Header>{client?.name}</Header>
      <Section>
        <div style={{ display: 'flex' }}>
          <SectionHeader>Address</SectionHeader>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: 19, width: 37 }}>Street</div>
              <TextField
                name="address"
                label=""
                width="300"
                value={client?.address || ''}
                onChange={e => changeClientInfo('address', e.target.value)}
                styles={{ input: { paddingLeft: 16 } }}
              />
              <div style={{ marginRight: 8, width: 48, marginLeft: 24 }}>Suite #</div>
              <TextField
                name="addressLine2"
                label=""
                width="150"
                value={client?.addressLine2 || ''}
                onChange={e => changeClientInfo('addressLine2', e.target.value)}
                styles={{ input: { paddingLeft: 16 } }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 24 }}>
              <div style={{ marginRight: 19, width: 37 }}>City</div>
              <TextField
                name="city"
                label=""
                width="534"
                value={client?.city || ''}
                onChange={e => changeClientInfo('city', e.target.value)}
                styles={{ input: { paddingLeft: 16 } }}
              />
            </div>
            <div style={{ display: 'flex', marginTop: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: 19, width: 37 }}>State</div>
                <Select
                  options={states}
                  value={client?.stateId || { value: null, label: '' }}
                  onChange={e => {
                    changeClientInfo('stateId', e);
                  }}
                  styles={customStyles}
                  placeholder={''}
                  components={{
                    IndicatorSeparator: null,
                  }}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: 24 }}>
                <div>Zip</div>
                <TextField
                  name="zip"
                  label=""
                  width="200"
                  value={client?.zip || ''}
                  onChange={e => changeClientInfo('zip', e.target.value)}
                  styles={{ marginLeft: 8, input: { paddingLeft: 16 } }}
                />
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <div style={{ display: 'flex' }}>
          <SectionHeader>Phone</SectionHeader>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div>Phone</div>
            <PhoneNumberInput
              name="phone"
              label=""
              width="264"
              value={client?.phone || ''}
              onChange={val => changeClientInfo('phone', val)}
              styles={{ marginLeft: 8, input: { paddingLeft: 16 } }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 24 }}>
            <div>Extension</div>
            <TextField
              name="extension"
              label=""
              width="177"
              value={client?.extension?.toString() || null}
              onChange={e => changeClientInfo('extension', e.target.value)}
              styles={{ marginLeft: 8, input: { paddingLeft: 16 } }}
            />
          </div>
        </div>
      </Section>
      <Section>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SectionHeader>Email</SectionHeader>
          <TextField
            name="email"
            label=""
            width="590"
            value={client?.email || ''}
            onChange={e => changeClientInfo('email', e.target.value)}
            styles={{ marginLeft: 8, input: { paddingLeft: 16 } }}
          />
        </div>
      </Section>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 32, marginRight: 30 }}>
        <div onClick={() => getClient()}>
          <Button buttonText="Cancel" buttonType="ButtonSecondarySmall" />
        </div>
        <div onClick={() => onSave(client)} style={{ marginLeft: 8 }}>
          <Button
            buttonText={success ? 'Saved Successfully!' : 'Save changes'}
            loadingStatus={loading}
            width="140px"
          />
        </div>
      </div>
    </OuterWrap>
  );
};

export default ProfilePage;
